module.exports = __webpack_public_path__ + "img/3_no.e8258b50.svg";